import { get } from 'lodash'

// Sets the validation status of the form (Valid / Invalid / None [untouched])
export const getFieldState = (form, field) => {
  const errors = get(form.errors, field.name)
  const touched = get(form.touched, field.name)
  if (errors && touched) return 'is-invalid'
  else if (touched) return 'is-valid'
  else return ''
}
